import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'


//put your own config from firebase project
var config = {
  apiKey: "AIzaSyB00rjetljbHzyGnwpnVZT3NOpbt3uuFdI",
  authDomain: "jd-workmanager.firebaseapp.com",
  databaseURL: "https://jd-workmanager.firebaseio.com",
  projectId: "jd-workmanager",
  storageBucket: "jd-workmanager.appspot.com",
  messagingSenderId: "143257436076",
  appId: "1:143257436076:web:faad72a2403d555a918409",
  measurementId: "G-4TS1989N3Z"
};

  firebase.initializeApp(config);
  // firebase.firestore().settings( { timestampsInSnapshots : true } )

  export default firebase;

  export const CreateUser = firebase.initializeApp(config, "CreateUser");

  /*   firestore rules

service cloud.firestore {
  match /databases/{database}/documents {

    match /projects/{project} {
      allow read, write : if request.auth.uid != null
    }
    match /users/{userId} {
      allow create
      allow read : if request.auth.uid != null
      allow write : if request.auth.uid == userId 
    }
    match /notifications/{notification} {
      allow read : if request.auth.uid != null
    }
  }
}


  */